
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/counsellors/[pageName]",
      function () {
        return require("private-next-pages/counsellors/[pageName].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/counsellors/[pageName]"])
      });
    }
  